import { render, staticRenderFns } from "./GlossarySearch.vue?vue&type=template&id=526d1928&"
import script from "./GlossarySearch.vue?vue&type=script&lang=js&"
export * from "./GlossarySearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('526d1928')) {
      api.createRecord('526d1928', component.options)
    } else {
      api.reload('526d1928', component.options)
    }
    module.hot.accept("./GlossarySearch.vue?vue&type=template&id=526d1928&", function () {
      api.rerender('526d1928', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/classPage/glossary/GlossarySearch.vue"
export default component.exports